import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
} from 'react';

import './prior_relationship_confirmation_modal.scss';

const PriorRelationshipConfirmationModal = (props) => {
  const {
    leadName,
    matchCreatedAt,
    show: propsShow,
    hideModal,
  } = props;

  const [show, setShow] = useState(false);
  const modalRef = useRef(null);

  const handleClosing = useCallback((newShow) => { setShow(newShow); }, []);

  useEffect(() => {
    if (propsShow !== undefined) {
      setShow(propsShow);
    }

    if (modalRef && modalRef.current) {
      modalRef.current.addEventListener('animationend', handleClosing.bind(null, propsShow));
    }

    return () => {
      if (modalRef && modalRef.current) {
        modalRef.current.removeEventListener('animationend', handleClosing.bind(null, propsShow));
      }
    };
  }, [propsShow]);

  const modalContainerClasslist = ['notify-loop-prior-relationship-confirmation-modal'];

  if (show) {
    modalContainerClasslist.push('show');
  }

  return (
    <div class={modalContainerClasslist.join(' ')}>
      <div class="notify-loop-prior-relationship-confirmation-modal-container">
        <button type="button" className="close-button" onClick={hideModal}>
          <i className="times" />
        </button>

        <h2 className="mb-15">Thank you for letting us know about your prior relationship with {leadName}</h2>

        <div className="text-left">
          <p className="mb-15">Per our <a href="/profile/account-settings/agent-terms" target="_blank">Agent Terms</a>, we require supporting documentation in order to review this claim.</p>

          <p className="mb-15">We will send you an email with further instructions. Please reply to that email with a copy of the contract establishing a working relationship between you and the client. The contract must be dated and signed prior to {matchCreatedAt}.</p>

          <p className="mb-15">If you have any questions, please email us at <a href="mailto:referralreviewteam@referralexchange.com">referralreviewteam@referralexchange.com</a>.</p>
        </div>

        <div className="button-container">
          <button type="button" onClick={hideModal}>Done</button>
        </div>
      </div>
    </div>
  );
};

export default PriorRelationshipConfirmationModal;
